import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  dialogTitle: string;
  dialogContentText: string;
  onYes: Function;
  onNo?: Function;
  isOpen: boolean;
  setIsOpen: Function;
};

export default function AlertDialog(props: Props) {
  const {
    dialogContentText,
    onYes,
    onNo,
    setIsOpen,
    dialogTitle,
    isOpen = false,
  } = props;

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleYes = () => {
    setIsOpen(false);
    onYes();
  };
  const handleNo = () => {
    setIsOpen(false);
    onNo();
  };

  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dialogContentText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleYes} autoFocus>
            Yes
          </Button>
          <Button onClick={handleNo}>No</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
